export default __webpack_public_path__ + "static/media/BookedPatientFill.b473dda2.svg";